import React from "react";
import { Link } from "react-router-dom";
// reactstrap components
import {
  Collapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  UncontrolledTooltip
} from "reactstrap";

function ExamplesNavbar() {
  const [navbarColor, setNavbarColor] = React.useState("navbar-transparent");
  const [collapseOpen, setCollapseOpen] = React.useState(false);
  React.useEffect(() => {
    const updateNavbarColor = () => {
      if (
        document.documentElement.scrollTop > 399 ||
        document.body.scrollTop > 399
      ) {
        setNavbarColor("");
      } else if (
        document.documentElement.scrollTop < 400 ||
        document.body.scrollTop < 400
      ) {
        setNavbarColor("navbar-transparent");
      }
    };
    window.addEventListener("scroll", updateNavbarColor);
    return function cleanup() {
      window.removeEventListener("scroll", updateNavbarColor);
    };
  });
  return (
    <>
      {collapseOpen ? (
        <div
          id="bodyClick"
          onClick={() => {
            document.documentElement.classList.toggle("nav-open");
            setCollapseOpen(false);
          }}
        />
      ) : null}
      <Navbar className={"fixed-top " + navbarColor} color="info" expand="lg">
        <Container>
          <div className="navbar-translate">

            <button
              className="navbar-toggler navbar-toggler "
                          style={{ position: 'fixed', top: 0, right: 0, display: (!collapseOpen) ? "block" : "none" }}
              onClick={() => {
                document.documentElement.classList.toggle("nav-open");
                setCollapseOpen(!collapseOpen);
              }}
              aria-expanded={collapseOpen}
              type="button"
              
            >
              <span className="navbar-toggler-bar top-bar"></span>
              <span className="navbar-toggler-bar middle-bar"></span>
              <span className="navbar-toggler-bar bottom-bar"></span>
            </button>
          </div>
                  <NavbarBrand
                      href="https://demos.creative-tim.com/now-ui-kit-react/index?ref=nukr-examples-navbar"
                      target="_blank"
                      id="navbar-brand"
                  >
                      ระบบรักษาทางไกล รพ.โรคผิวหนังเขตร้อนภาคใต้ จ.ตรัง
            </NavbarBrand>
          <Collapse
            className="justify-content-end"
            isOpen={collapseOpen}
            navbar
          >
                      <Nav navbar>
                          <NavItem>
                              <NavLink
                                  href="https://www.facebook.com/trangskin" target="_blank"
                                  id="facebook-tooltip"
                              >
                                  <i className="fab fa-facebook-square"></i>
                                  <p className="d-lg-none d-xl-none">Facebook</p>
                              </NavLink>
                              <UncontrolledTooltip target="#facebook-tooltip">
                                  Like us on Facebook
                </UncontrolledTooltip>
                          </NavItem>
                          <NavItem>
                              <NavLink
                                  href="https://www.youtube.com/channel/UCpwQPYC7vbgbFJsYo4LStAw" target="_blank"
                                  id="youtube-tooltip"
                              >
                                  <i className="fab fa-youtube"></i>
                                  <p className="d-lg-none d-xl-none">Youtube</p>
                              </NavLink>
                              <UncontrolledTooltip target="#youtube-tooltip">
                                  Subscribe us on Youtube
                </UncontrolledTooltip>
                          </NavItem>
                          <NavItem>
                              <NavLink
                                  href="http://www.trangskin.go.th" target="_blank"
                                  id="web-tooltip"
                              >
                                  <i className="fab fa-internet-explorer"></i>
                                  <p className="d-lg-none d-xl-none">trangskin.go.th</p>
                              </NavLink>
                              <UncontrolledTooltip target="#web-tooltip">
                                  More information on trangskin.go.th
                </UncontrolledTooltip>
                          </NavItem>
                      </Nav>
          </Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default ExamplesNavbar;
